import { makeAutoObservable, flow } from 'mobx'

import * as srv from 'admin/services'
import handleError from 'admin/services/error-handler'

export default class RespondIoSettingStore {
  loading = false
  openDialog = false
  setting = {
    whatsappChannelId: '',
  }

  constructor() {
    makeAutoObservable(this, {
      fetch: flow,
    })
  }

  setOpenDialog = (value) => {
    this.openDialog = value
  };

  *fetch() {
    try {
      this.loading = true
      const response = yield srv.fetchRespondIoSetting()
      if (response.ok) {
        this.setting = {
          whatsappChannelId: response.data.whatsappChannelId || '',
        }
        return response.data
      }
      throw handleError(response)
    } catch (error) {
      return null
    } finally {
      this.loading = false
    }
  }
}
